import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './FeatureCardItem.css';
import ScrollAnimation from 'react-animate-on-scroll';
import { canUseDOM, get, injectImageResolution } from '../../utils';
import LazyPicture from '../atoms/LazyPicture';
import RouterLink from '../atoms/RouterLink';
import { ReactComponent as IconChevronRightLight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../resources/icons/IconChevronLeftLight.svg';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import React, { useContext, useEffect, useRef, useState } from 'react';
import throttle from 'lodash/throttle';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
var FeatureCardItem = function FeatureCardItem(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    introHeight = _useState2[0],
    setIntroHeight = _useState2[1];
  var itemWrapperRef = useRef(null);
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var countHeights;
  if (canUseDOM) {
    countHeights = throttle(function () {
      if (itemWrapperRef.current) {
        setIntroHeight(itemWrapperRef.current.querySelector('.description').offsetHeight);
      }
    }, 300);
  }
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return function () {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(function () {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize]);
  var title = get(props, 'title.jss');
  var description = get(props, 'description.jss');
  var hasDescription = get(props, 'description.jss.value');
  var hasTitle = get(props, 'title.jss.value');
  var image = get(props, 'image.jss.value.src');
  var alt = get(props, 'image.jss.value.alt');
  var CtaHref = get(props, 'cTALink.jss.value.href');
  var CtaTarget = get(props, 'cTALink.jss.value.target');
  var CtaLinktype = get(props, 'cTALink.jss.value.linktype');
  var eventsAnalytics = props.eventsAnalytics,
    params = props.params;
  return /*#__PURE__*/React.createElement(RouterLink, {
    className: "".concat(commonStyles, " ").concat(!CtaHref && specificStyles),
    href: CtaHref,
    linktype: CtaLinktype,
    linksTarget: CtaTarget
  }, /*#__PURE__*/React.createElement("div", {
    className: 'item',
    style: {
      '--descs-height': introHeight
    },
    ref: itemWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-container",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), [title.value]);
    }
  }, image && /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 992px)",
    srcSet: "".concat(injectImageResolution(image, 700, props.itemsToShow === 3 ? 700 : 525))
  }), /*#__PURE__*/React.createElement("img", {
    src: "".concat(injectImageResolution(image, 768, 768)),
    alt: alt
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-container",
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['titleClickAnalytics'], params), [title.value]);
    }
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, hasTitle && /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "title",
    field: title
  }))), props.mobileDevice ? /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "description-wrapper"
  }, hasDescription && /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: description
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "description-wrapper"
  }, hasDescription && /*#__PURE__*/React.createElement(Text, {
    className: "description",
    tag: "p",
    field: description
  })), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "cta-wrapper",
    onClick: function onClick(e) {
      e.stopPropagation();
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['readMoreAnalytics'], params), [title.value, props.readmore]);
    }
  }, CtaHref && /*#__PURE__*/React.createElement(RouterLink, {
    className: "btn-tertiary btn-tertiary--carousel",
    title: 'Read more',
    href: CtaHref,
    linktype: CtaLinktype,
    linksTarget: CtaTarget
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text"
  }, props.readmore), rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null)))))));
};
var specificStyles = "s44hcgv";
var commonStyles = "c1ckjc8x";
export default FeatureCardItem;